import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import STab from '../index';
import DsRoomCard from './STab-Room';
import DsExtraCard from './Stab-Extra';
import DsGuestCard from './STab-RoomGuests';
import TabContainer from './tabContainer';
import BecomeMemberInMyBooking from '../../../../loyalty/BecomeMemberInMyBooking';
import UserDataTab from '../../../../loyalty/UserDataTab';

const TabBase = (props) => {
  const {
    chain, booking, lang, buildUrl, onShare, children,
  } = props;
  return (
          <TabContainer
                  booking={booking}
                  lang={lang}
                  chain={chain}
                  buildUrl={buildUrl}
                  onShare={onShare}
          >
            {children}
          </TabContainer>
  );
};

const MyBookingTab = (props, context) => {
  const {
    booking, className,
  } = props;
  const { locator, rooms } = booking;
  const RoomTab = (
          <TabBase {...props}>
            {rooms.map((room, index) => (
                    <DsRoomCard
                            key={`${room.code}_${index}`}
                            room={room}
                            roomIndex={index + 1}
                            booking={booking}
                            className="w-full py-4"
                    />
            ))}
          </TabBase>
  );
  // eslint-disable-next-line no-unused-vars
  const GuestTab = (
          <TabBase {...props}>
            {rooms.map((room, index) => (
                    <DsGuestCard
                            key={`${room.code}_${index}`}
                            room={room}
                            roomIndex={index}
                            locator={locator}
                            booking={booking}
                            className="w-full py-4"
                    />
            ))}
          </TabBase>
  );

  const LoyaltyTab = (
          <TabBase {...props}>
            {!props.loggedUser && <BecomeMemberInMyBooking
                    coins={props.booking.loyalty.coins_to_be_granted || 0}
                    lang={props.lang}
                    loyalty={props.loyalty}
                    loggedUser={props.loggedUser}
            />}
            {props.loggedUser
            && <UserDataTab
                    chainData={props.chainData}
                    coins={props.booking.loyalty.coins_to_be_granted || 0}
                    lang={props.lang}
                    loyalty={props.loyalty}
                    usedCoins={props.booking.loyalty}
                    booking={props.booking}
            />
            }
          </TabBase>
  );

  const hasExtras = rooms.filter((room) => room.extra);
  let ExtrasTab = {};
  if (hasExtras.length) {
    ExtrasTab = (
                  <TabBase {...props}>
                    {rooms.map((room, index) => (
                            <DsExtraCard
                                    key={`${room.code}_${index}`}
                                    room={room}
                                    roomIndex={index + 1}
                                    booking={booking}
                                    className="w-full py-4"
                            />
                    ))}
                  </TabBase>
    );
  }

  const tabs = [
    { id: 'Rooms', name: context.t('Rooms'), content: RoomTab },
    /*{ id: 'Guests', name: context.t('Guests'), content: GuestTab },*/
    { id: 'Loyalty', name: context.t('Loyalty'), content: LoyaltyTab },
    ...(hasExtras.length ? [{ id: 'Extras', name: context.t('Extras'), content: ExtrasTab }] : []),
  ];

  const tabQuery = props.query.get('tab');
  const defaultTab = tabQuery ? tabs.filter((tab) => tab.id.toUpperCase() === tabQuery.toUpperCase()) : null;
  return <STab className={className} defaultTab={defaultTab && defaultTab[0].id} tabs={tabs}/>;
};

MyBookingTab.propTypes = {
  buildUrl: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
};

MyBookingTab.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  loggedUser: state.loyalty.loggedUser,
}))(MyBookingTab);
